<template>
  <div class="how-to page">
    <div class="article">
      <h3>1. 로그인</h3>
      <p>로그인 창에서 이름과 학번을 입력합니다.</p>
      <p>*이름과 학번이 매치되지 않을 경우 로그인이 되지 않습니다.</p>

      <h3>2. 홈페이지</h3>
      <p>홈페이지에서는 다음 정보를 한 눈에 볼 수 있습니다.</p>
      <p>4개 엘리베이터의 현재 위치와 방향</p>
      <p>택배 도착 여부</p>
      <p>오늘의 식단표</p>
      <p>이번 주 법정 참석 여부</p>

      <h3>3. 엘리베이터</h3>
      <p>
        왼쪽 위의 파란 아이콘을 누르면 엘리베이터 상세설명 페이지에 오게 됩니다.
      </p>
      <p>여기서는 각 엘리베이터의 위치와 방향을 확대하여 볼 수 있습니다.</p>

      <h3>4. 택배리스트</h3>
      <p>
        홈페이지에서 빨간색 아이콘을 누르면 택배 상세설명 페이지에 오게 됩니다.
      </p>
      <p>여기서는 택배리스트의 텍스트화 버전을 볼 수 있습니다.</p>
      <p>
        가끔씩 사감선생님께서 이름을 잘못 쓰실 때를 대비하여 이름이
        데이터베이스와 매칭이 되지 않을 시에 ‘분류할 수 없는 택배’ 리스트로
        이름이 표시됩니다.
      </p>
      <p>택배리스트 사진을 직접 확인해 볼 수도 있습니다.</p>

      <h3>5. 식단표</h3>
      <p>
        홈페이지의 파란색 아이콘을 클릭하면 급식 상세설명 페이지에 들어갈 수
        있습니다.
      </p>
      <p>여기서는 급식과 혼정빵의 사진을 볼 수 있습니다.</p>
      <p>학생들이 직접 혼정빵 사진을 찍어 올릴 수 있습니다.</p>

      <h3>6. 법정리스트</h3>
      <p>
        홈페이지에서 노란색 아이콘을 누르면 전체 법정리스트를 볼 수 있습니다.
      </p>
      <p>
        택배리스트와 마찬가지로 직접 법정리스트의 원본을 확인해 볼 수도
        있습니다. 아울러 누계 확인 기능은 현재 개발 중입니다.
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>